import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BooleanType } from '../enums/boolean-type';
import { BooleanTypeEntity } from '../entities/boolean-type.entity';
import { isNil } from '@web/utils';
import { BooleanTypeNotFoundException } from '../exceptions/boolean-type-not-found.exception';

@Injectable({
  providedIn: 'root',
})
export class BooleanTypeProviderService {
  private readonly records = new Map([
    [BooleanType.TRUE, 'Tak'],
    [BooleanType.FALSE, 'Nie'],
  ]);

  public fetchAll(): Observable<BooleanTypeEntity[]> {
    const entities = Array.from(this.records.entries()).map(
      ([key, label]) => new BooleanTypeEntity(key, label),
    );

    return of(entities);
  }

  public fetchByName(type: BooleanType): Observable<BooleanTypeEntity> {
    const label = this.records.get(type);

    if (isNil(label)) {
      throw new BooleanTypeNotFoundException();
    }

    return of(new BooleanTypeEntity(type, label));
  }
}
